<template>
  <router-view />
</template>

<route>
{
  "redirect": "/msp/global_settings/administrators",
  "name": "MSP Global Settings"
}
</route>

<script>
import { mapActions } from "vuex";
export default {
  layout: "msp",
  methods: mapActions("pageMeta", ["setPageTitle"]),
  created() {
    this.setPageTitle(this.$t("Settings"));
  },
};
</script>
